module.exports = (__webpack_require__("dll-reference vendor_7ba712b40ab14c215732"))("./node_modules/@fortawesome/pro-light-svg-icons/index.mjs");